import { api } from '@services';

import Document, { IDocument, IDocumentApiModel } from '@models/Document.model';

interface INewContact {
  documentId: string;
  manufacturerId?: string;
  productIds?: string[];
  haveOwnerStudio?: boolean;
  label?: string;
  uri?: string;
  file?: File;
  description?: string;
  isGlobal?: 'true' | 'false';
  favorite?: 'true' | 'false';
}
interface IManufacturerVariables {
  data: INewContact;
}

const patchDocument = async ({
  data,
}: IManufacturerVariables): Promise<IDocument> => {
  const formData = new FormData();
  if (data.file) formData.append('file', data.file);
  if (data.uri) formData.append('uri', data.uri);
  if (data.description) formData.append('description', data.description);
  if (data.manufacturerId)
    formData.append('manufacturerId', data.manufacturerId);
  if (data.productIds) formData.append('productIds', data.productIds.join(','));
  if (data.haveOwnerStudio)
    formData.append('haveOwnerStudio', data.haveOwnerStudio ? 'true' : 'false');
  if (data.label) formData.append('label', data.label);
  if (data.favorite !== undefined) formData.append('favorite', data.favorite);
  if (data.isGlobal !== undefined) formData.append('isGlobal', data.isGlobal);

  const { data: document } = await api.patch<IDocumentApiModel>(
    `/documents/${data.documentId}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return Document.fromApiModel(document);
};

export { patchDocument };
